export default __webpack_public_path__ + "static/media/white.818cc5f7.svg";